import { clsx, ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * A utility to make it easier to conditionally add Tailwind CSS classes
 */
export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}
